module.exports = __webpack_public_path__ + "static/media/ecoicons.4e2af971.woff";